"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const IMAGE_BASE = "/image/new-version/casting/Vacuum-Casting/Industries";

const ITEMS = [
	{ keyPrefix: "applicationsItem1" },
	{ keyPrefix: "applicationsItem2" },
	{ keyPrefix: "applicationsItem3" },
	{ keyPrefix: "applicationsItem4" },
	{ keyPrefix: "applicationsItem5" },
] as const;

const IMAGES = [
	{ src: `${IMAGE_BASE}/vacuum-casting-parts-1.webp`, altKey: "applicationsImageAlt1" },
	{ src: `${IMAGE_BASE}/vacuum-casting-parts-2.webp`, altKey: "applicationsImageAlt2" },
	{ src: `${IMAGE_BASE}/vacuum-casting-parts-3.webp`, altKey: "applicationsImageAlt3" },
	{ src: `${IMAGE_BASE}/vacuum-casting-parts-4.webp`, altKey: "applicationsImageAlt4" },
] as const;

export default function VacuumCastingApplications() {
	const t = useTranslations("new-vacuum-casting");

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="grid grid-cols-1 gap-8 lg:grid-cols-[65fr_35fr] lg:gap-12">
					<div>
						<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
							{t("applicationsTitle")}
						</h2>
						<p className="mb-6 text-sm leading-relaxed text-black sm:mb-8 md:mb-10 md:text-base">
							{t("applicationsDesc")}
						</p>

						<div className="grid grid-cols-1 gap-x-8 gap-y-5 sm:grid-cols-2">
							{ITEMS.map((item, index) => (
								<div
									key={item.keyPrefix}
									className={index === ITEMS.length - 1 ? "sm:col-span-2" : undefined}
								>
									<h3 className="mb-2 text-base font-semibold text-themePrimary400 sm:text-lg">
										{t(`${item.keyPrefix}Title`)}
									</h3>
									<p className="text-sm leading-relaxed text-black md:text-base">
										{t(`${item.keyPrefix}Desc`)}
									</p>
								</div>
							))}
						</div>
					</div>

					<div className="grid grid-cols-2 gap-4 sm:gap-5">
						{IMAGES.map((img) => (
							<div
								key={img.src}
								className="relative aspect-square w-full overflow-hidden rounded-2xl bg-[#ededed]"
							>
								<Image
									src={img.src}
									alt={t(img.altKey)}
									fill
									className="object-contain p-4 sm:p-6"
									sizes="(max-width: 1024px) 50vw, 35vw"
								/>
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}
